import { createSlice } from '@reduxjs/toolkit';
import { getCookieConsentValue } from "react-cookie-consent";

const isCookieConsentBannerOpen = () => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true" || isConsent === "false") {
        return false;
    }
    return true
}

export const isCookieConsentOpenSlice = createSlice({
    name: 'isCookieConsentOpen',
    initialState: {
      value: isCookieConsentBannerOpen(),
    },
    reducers: {
        setIsCookieConsentOpen: (state, action) => {
            state.value = action.payload;
        },
    }
});

export const { setIsCookieConsentOpen } = isCookieConsentOpenSlice.actions;

export default isCookieConsentOpenSlice.reducer;